import { render, staticRenderFns } from "./editFreightInvoice.vue?vue&type=template&id=5a7b931a"
import script from "./editFreightInvoice.vue?vue&type=script&lang=js"
export * from "./editFreightInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports